import { render, staticRenderFns } from "./IndexPatentSearchItems.vue?vue&type=template&id=1f8809e4&scoped=true&"
import script from "./IndexPatentSearchItems.vue?vue&type=script&lang=js&"
export * from "./IndexPatentSearchItems.vue?vue&type=script&lang=js&"
import style0 from "./IndexPatentSearchItems.vue?vue&type=style&index=0&id=1f8809e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8809e4",
  null
  
)

export default component.exports